<template>
	<form
		action=""
		@click="form.onFormFocus"
	>
		<v-text-field
			v-model="form.email.model"
			:label="$t('E-mail')"
			variant="underlined"
			class="mb-2"
			:error="!form.email.$valid && form.email.$touched"
			:error-messages="[
				...(form.email.$errors.required && form.email.$touched ? [$t('This field is required')] : []),
				...(form.email.$errors.request ? [form.email.$errors.request] : []),
			]"
			@blur="form.email.onFieldBlur"
			@keyup.enter="submit"
		/>

		<v-text-field
			v-model="form.password.model"
			:label="$t('Password')"
			variant="underlined"
			class="mb-2"
			type="password"
			:error="!form.password.$valid && form.password.$touched"
			:error-messages="[
				...(form.password.$errors.required && form.password.$touched ? [$t('This field is required')] : []),
				...(form.password.$errors.request ? [form.password.$errors.request] : []),
			]"
			@blur="form.password.onFieldBlur"
			@keyup.enter="submit"
		/>

		<div
			v-if="form.formErrors.length"
			class="my-2 px-3 py-3"
			style="background: #ffdfdd; color: #ea4c42"
		>
			<p
				v-for="error in form.formErrors"
				:key="error"
			>
				{{ error }}
			</p>
		</div>

		<div class="pt-3">
			<v-btn
				color="primary"
				:loading="form.$loading"
				@click="submit"
			>
				{{ $t('Sign in') }}
			</v-btn>
		</div>
	</form>
</template>

<script>
import FormManager from '@/services/formManager/formManagerService'
import { required } from '@/services/formManager/formValidators'
import { watch, toRefs } from 'vue'

export default {
	props: {
		requestLoading: {
			type: Boolean,
			default: () => false,
		},
		isVisible: {
			type: Boolean,
			default: () => false,
		},
		extraFieldsErrors: {
			type: Object,
			default: () => ({}),
		},
	},
	setup(props, { emit }) {
		const { requestLoading, isVisible, extraFieldsErrors } = toRefs(props)

		const form = FormManager({
			fields: {
				email: {
					validators: {
						required: (value) => required(value),
					},
					defaultValue: () => '',
				},
				password: {
					validators: {
						required: (value) => required(value),
					},
					defaultValue: () => '',
				},
			},
		})

		const submit = async () => {
			const isValid = await form.validateForm()

			if (!isValid) return

			emit('submit', form.getFormValues())
		}

		watch(
			() => requestLoading.value,
			() => form.setFormLoading(requestLoading.value)
		)

		watch(
			() => isVisible.value,
			() => !isVisible.value && form.resetForm()
		)

		watch(
			() => extraFieldsErrors.value,
			() =>
				form.setFormErrors(
					Object.fromEntries(
						Object.entries(extraFieldsErrors.value).map(([fieldName, errors]) => [fieldName, { request: errors }])
					),
					{ touch: true }
				)
		)

		return {
			form,
			submit,
		}
	},
}
</script>
